import { Theme, useMediaQuery } from '@mui/material';

// import { ModalContentContainer } from '@/components';
import { Modals } from '@/constants';

import { OnboardingForm } from '../../../OnboardingForm';
import { AppModal } from '../AppModal';

export const OnboardingModal = () => {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md'),
  );

  return (
    <AppModal
      modalName={Modals.ONBOARDING}
      disableBackdropClick
      disableEscapeKeyDown
      fullScreen={isMobile}>
      <OnboardingForm />
    </AppModal>
  );
};
